import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseInvalidBankAccountNumberWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.purchase.validation.bank-account-number.message');
    }
}
